import React, { useState } from "react";
import { LegStyles } from "./LegStyles";

const Legs = ({
  overrideStep,
  legsModels,
  legsMaterials,
  activeProduct,
  setActiveProduct,
  setOverrideStep,
  isActive,
  setActiveStep,
  setLegPrice,
  basePrice,
  notFull = false,
}) => {
  const handleNextStep = () => {
    setOverrideStep((prev) => prev + 1);
  };
  const handlePrevStep = () => {
    setOverrideStep((prev) => prev - 1);
  };
  if (overrideStep == 2) {
    setActiveStep();
  }
  const [state, setState] = useState({
    completedBoard: false,
    completedLegMaterials: false,
    completedModels: false,
    activeItem: null,
    boardMaterial: null,
    boardWeight: null,
    legMaterial: null,
    legColor: null,
    legModel: null,
    isIncreased: null,
  });
  return (
    isActive && (
      <LegStyles
        activeStep={overrideStep + 2}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        legsModels={legsModels}
        legsMaterials={legsMaterials}
        activeProduct={activeProduct}
        setActiveProduct={setActiveProduct}
        notFull={notFull}
        basePrice={basePrice}
        setLegPrice={setLegPrice}
        setOverrideStep={setOverrideStep}
        state={state}
        setState={setState}
      />
    )
  );
};

export default Legs;
